/**
 * Sommaires des pages de politiques.
 *
 * L'editeur de politiques de Shopify nettoie le HTML colle : il supprime
 * les balises <section> et <header>, ainsi que TOUS les attributs id.
 * Constate a la mesure sur les sept politiques : 81 liens de sommaire
 * pointant vers des ancres inexistantes.
 *
 * Les liens, eux, survivent. Le script recree donc les identifiants en
 * appariant, dans l'ordre du document, les liens du sommaire et les
 * sections. L'ordre est fiable : chaque sommaire est ecrit dans l'ordre
 * des sections qu'il annonce.
 *
 * Sur les pages ordinaires, ou les id survivent, la verification
 * « document.getElementById » suffit a ne rien toucher.
 */
(function () {
  var pages = document.querySelectorAll('.ef-page');

  Array.prototype.forEach.call(pages, function (page) {
    var liens = [].slice.call(page.querySelectorAll('.ef-sommaire a[href^="#"]'));
    if (!liens.length) return;

    var sections = [].slice.call(page.querySelectorAll('.ef-sect'));

    /* Moins de sections que de liens : l'appariement serait faux. On
       prefere ne rien faire plutot que de creer de mauvaises ancres. */
    if (sections.length < liens.length) return;

    liens.forEach(function (lien, i) {
      var cible = lien.getAttribute('href').slice(1);
      if (!cible || document.getElementById(cible)) return;
      if (!sections[i].id) sections[i].id = cible;
    });
  });
})();
